export default __webpack_public_path__ + "static/Identity-HeroSection-4b0b5e7d2cd4158a86aec36f14b5e688.png";